<ng-container *ngIf="!!params">
    <tt-checkbox ttLabel="activeproduct" [(ttModel)]="params.activeproduct" (ttModelChange)="onChanged('activeproduct')"></tt-checkbox>
    <tt-checkbox ttLabel="hide_in_webshop" [(ttModel)]="params.hide_in_webshop" (ttModelChange)="onChanged('hide_in_webshop')"></tt-checkbox>
    <tt-checkbox ttLabel="directpurchase" [(ttModel)]="params.directpurchase" (ttModelChange)="onChanged('directpurchase')"></tt-checkbox>
    <tt-checkbox ttLabel="exclude_from_cost_distribution" [(ttModel)]="params.exclude_from_cost_distribution" (ttModelChange)="onChanged('exclude_from_cost_distribution')"></tt-checkbox>
    <tt-checkbox
        *ngIf="params.show_require_best_before_date === '1'"
        ttLabel="require_best_before_date"
        [(ttModel)]="params.require_best_before_date"
        (ttModelChange)="onChanged('require_best_before_date')"
    ></tt-checkbox>
    <tt-input-number ttLabel="days_of_durability" [(ttModel)]="params.days_of_durability" (ttModelChange)="onChanged('days_of_durability')" ttTextAlign="right" ttDecimals="0"></tt-input-number>
    <tt-checkbox
        *ngIf="params.show_require_suppliers_batchno === '1'"
        ttLabel="require_suppliers_batchno"
        [(ttModel)]="params.require_suppliers_batchno"
        (ttModelChange)="onChanged('require_suppliers_batchno')"
    ></tt-checkbox>
    <tt-select
        ttLabel="customstarif"
        [(ttModel)]="params.customstarif_id"
        (ttModelChange)="onChanged('customstarif_id')"
        [ttData]="customsTarifs"
        ttDataId="customstarif_id"
        ttDataName="customstarif_name"
        ttShowClearButton
        [ttClearValue]="''"
    >
        <tt-form-field-button buttons ttIcon="fas fa-bars" ttGoto="customstarifs"></tt-form-field-button>
    </tt-select>
    <tt-input *ngIf="params.setting_product_show_prod_text3 !== '0'" ttLabel="prod_text3" [(ttModel)]="params.prod_text3" (ttModelChange)="onChanged('prod_text3')"></tt-input>
    <tt-textarea *ngIf="params.show_prod_text2 === '1'" ttLabel="prod_text2" [(ttModel)]="params.prod_text2" (ttModelChange)="onChanged('prod_text2')"></tt-textarea>
    <tt-input *ngIf="params.setting_product_show_drawing_no !== '0'" ttLabel="drawing_no" [(ttModel)]="params.drawing_no" (ttModelChange)="onChanged('drawing_no')"></tt-input>
    <tt-input *ngIf="params.setting_product_show_drawing_rev !== '0'" ttLabel="drawing_rev" [(ttModel)]="params.drawing_rev" (ttModelChange)="onChanged('drawing_rev')"></tt-input>

    <ng-container *ngIf="params.sr === '1'">
        <tt-input ttLabel="special_prod_id_view" [(ttModel)]="params.special_prod_id_view" (ttModelChange)="onChanged('special_prod_id_view')"></tt-input>
        <tt-search
            ttLabel="special_prod_name_view"
            [(ttModel)]="params.special_prod_name_view"
            [ttSearch]="searchResources"
            (ttOnSelected)="onResourceSelected($event)"
            (ttOnClear)="onResourceSelected()"
        ></tt-search>
        <tt-input ttLabel="special_main_resource_id" [(ttModel)]="params.special_main_resource_id" (ttModelChange)="onChanged('special_main_resource_id')"></tt-input>
        <tt-input ttLabel="special_custom_prefix" [(ttModel)]="params.special_custom_prefix" (ttModelChange)="onChanged('special_custom_prefix')"></tt-input>
        <tt-input ttLabel="frr_id" [(ttModel)]="params.frr_id" (ttModelChange)="onChanged('frr_id')"></tt-input>
    </ng-container>
    <tt-input *ngIf="params.show_thread === '1'" ttLabel="thread" [(ttModel)]="params.thread" (ttModelChange)="onChanged('thread')"></tt-input>
    <tt-input-number
        *ngIf="params.prodtype_no === '0' || params.prodtype_no === '3'"
        ttLabel="deliverytime_before"
        [(ttModel)]="params.deliverytime_before"
        (ttModelChange)="onChanged('deliverytime_before')"
        ttTextAlign="right"
        ttDecimals="0"
    ></tt-input-number>
    <tt-select
        *ngIf="params.show_discgrpprod === '1'"
        ttLabel="discgrpprod"
        [(ttModel)]="params.discgrpprod_keyno"
        (ttModelChange)="onChanged('discgrpprod_keyno')"
        [ttData]="discountGroupProducts"
        ttDataId="discgrpprod_keyno"
        ttDataName="discgrpprod_name"
        ttShowClearButton
    ></tt-select>
</ng-container>
